// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#16A34A", // LifeShot Green
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F3F4F6", // Soft gray
    },
    background: {
      default: "#FFFFFF", // Clean white
      paper: "#F9FAFB",   // Cards
    },
    text: {
      primary: "#111827",   // Strong but not harsh
      secondary: "#4B5563", // Softer gray
    },
    error: {
      main: "#DC2626",
    },
    divider: "#E5E7EB",
  },

  typography: {
    fontFamily: "'Inter', 'Roboto', 'Arial', sans-serif",

    h4: {
      fontWeight: 700,
      fontSize: "1.4rem", // better for phones
      color: "#111827",
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.05rem",
      color: "#111827",
    },
    body1: {
      fontSize: "0.95rem", // mobile-friendly
      color: "#374151",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.85rem",
      color: "#6B7280",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      fontSize: "0.95rem",
    },
  },

  shape: {
    borderRadius: 14,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "12px 18px", // better tap area on phone
          minHeight: 44,        // mobile accessibility
          fontWeight: 600,
          transition: "all 0.2s ease-in-out",
        },

        containedPrimary: {
          backgroundColor: "#16A34A",
          "&:hover": {
            backgroundColor: "#15803D",
            boxShadow: "0 4px 12px rgba(22, 163, 74, 0.25)",
          },
        },

        outlined: {
          borderColor: "#D1D5DB",
          color: "#111827",
          "&:hover": {
            backgroundColor: "#F3F4F6",
          },
        },

        containedError: {
          backgroundColor: "#DC2626",
          "&:hover": {
            backgroundColor: "#B91C1C",
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)", // lighter for mobile
          padding: "16px", // less cramped on phone
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 6,
          borderRadius: 4,
          backgroundColor: "#E5E7EB",
        },
        bar: {
          borderRadius: 4,
          backgroundColor: "#16A34A",
        },
      },
    },

    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          height: 60, // phone nav comfort
          borderTop: "1px solid #E5E7EB",
        },
      },
    },
  },
});

export default theme;
